import { useQuery } from 'react-query';

import { BaseModel } from './api/types';
import { fetchParcPalette } from './api/palette';
import { fetchWarehouses } from './api/warehouses';
import { fetchSuppliers } from './api/supplier';

export const usePalettes = (organizationId: string) => {
    return useQuery<BaseModel[], Error>(['parcsPalette', organizationId], async () => {
        const data = await fetchParcPalette();
        return data
            .filter((parc) => {
                const orgId =
                    typeof parc.organization === 'string'
                        ? parc.organization
                        : (parc.organization as any)?.id ?? (parc.organization as any)?._id;
                return orgId === organizationId;
            })
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    });
};

export const useWarehousesByOrganization = (organizationId: string) => {
    return useQuery<BaseModel[], Error>(['wareHouses', organizationId], async () => {
        const data = await fetchWarehouses();
        return data
            .filter((w) => {
                const orgId =
                    typeof w.organization === 'string'
                        ? w.organization
                        : (w.organization as any)?.id ?? (w.organization as any)?._id;
                return orgId === organizationId;
            })
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    });
};

export const useSupplierByOrganization = (organizationId: string) => {
    return useQuery<BaseModel[], Error>(['suppliers', organizationId], async () => {
        const data = await fetchSuppliers();
        return data
            .filter((s) => {
                const orgId =
                    typeof s.organization === 'string'
                        ? s.organization
                        : (s.organization as any)?.id ?? (s.organization as any)?._id;
                return orgId === organizationId;
            })
            .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
    });
};
